import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { User } from 'app/core/models/user.model';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { UsersService } from 'app/core/services/users.service';

@Component({
    selector: 'app-provider-data-review-assignments',
    templateUrl: './provider-data-review-assignments.component.html',
    styleUrls: ['./provider-data-review-assignments.component.scss'],
    imports: [FaIconComponent,
              FormsModule,
              NgSelectComponent,
              MatProgressSpinner,
            ]
})

export class ProviderDataReviewAssignmentsComponent implements OnInit {
  private usersService = inject(UsersService);
  private authService = inject(AuthenticationService);

  @Input() assignedTo: User;
  @Input() defaultToCurrentUser = true;
  @Input() displayForList = false;
  @Input() showAssignmentsLabel = true;

  @Output() assignmentUpdate = new EventEmitter<number>();
  @Output() assignmentCanceled = new EventEmitter();
  @Output() assignmentClearSelection = new EventEmitter();

  assignedToUsers: User[] = [];
  assignedToId;

  canManageProviderData = false;
  loading = true;

  ngOnInit() {
    this.canManageProviderData = this.authService.hasPermissionTo(UserRoleName.manageProviderData);
    this.assignedToId = this.assignedTo?.id
    if (!this.assignedToId && this.defaultToCurrentUser) {
      this.assignedToId = this.authService.currentUser.id;
    }
    this.loadAssignedToUsers();
  }

  onCancel() {
    this.assignmentCanceled.emit();
  }

  onUpdate() {
    this.assignmentUpdate.emit(this.assignedToId);
  }

  onClearSelection() {
    this.assignmentClearSelection.emit();
  }

  private loadAssignedToUsers() {
    this.usersService.getByUserRole([UserRoleName.manageProviderData]).subscribe((result) => {
      this.assignedToUsers = [{ id: -1, fullName: 'UNASSIGN' } as User].concat(result.users);
      this.loading = false;
    });
  }
}
